
import React, { useEffect, useState } from "react";

import Breadcrumb from "../../../components/common/Breadcrumb";

import { NavLink, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addOnOrderListById, orderDetailsById, orderJobListById } from "../../../redux/reducers/myOrdersSlice";
import { formatDate } from "../../../utils/getDateinSlashFormat";
import { getDateTimeValue, getDateValue, getDateValueWithSingleTime } from "../../../utils/getDate";
import { formatTimeRange } from "../../../utils/formattedTimeRange";
import { getPriceFormatted } from "../../../utils/getPriceFormatted";
import OrderDetailsJobList from "./OrderList/OrderDetailsJobList";
import AddOnOrderDetailsList from "./OrderList/AddOnOrderDetailsList";
import { ArrowLeftIcon } from "@mui/x-date-pickers";
import { getPaymentDetailsOrder, updatePaymentRequest } from "../../../services/api/ordersApis";
import PaymentStatusModal from "./PaymentStatusModal";

const OrderDetails = () => {
  const dispatch = useDispatch()
  let { id } = useParams();
  const [searchParams] = useSearchParams();
  const { myOrdersDetails, addOnOrderListToShowById, jobOrdersListsById } = useSelector((state) => state.orders)
  const { user } = useSelector((state) => state.auth)
  const navigate = useNavigate()
  const [paymentDetails, setpaymentDetails] = useState({})
  const [isOpen, setIsOpen] = useState(false)
  let selectedServiceList = [...new Set(myOrdersDetails?.services?.map(item => item?.priceDetails?.serviceType))]

  useEffect(() => {
    if (id) {
      if (!user) {
        sessionStorage.setItem("reDirect_url", `${window.location.pathname}${window.location.search}`)
        navigate('/login')
      }
      else {
        if (!!searchParams.get('status') && searchParams.get('reference')) {
          searchParams.get('status') === 'completed' && setIsOpen(true)
          // Update payment status 
          let body = {
            payment_request_id: searchParams.get('reference')
          }
          if (searchParams.get('status') === 'completed') {
            navigate(`/order-details/${id}`, { replace: true })
            body = {
              ...body,
              status: "succeeded"
            }
          }
          else {
            navigate('/dashboard')
            body = {
              ...body,
              status: "failed"
            }
          }
          // updatePaymentRequest({ body, dispatch, getPaymentDetails, id })

          dispatch(orderDetailsById(id));
          dispatch(orderJobListById(id));
          dispatch(addOnOrderListById(id));
          getPaymentDetails();
        }
        else {
          dispatch(orderDetailsById(id))
          dispatch(orderJobListById(id))
          dispatch(addOnOrderListById(id))
          getPaymentDetails()
        }
      }
    }

  }, [id])
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const getPaymentDetails = async () => {
    let data = await getPaymentDetailsOrder(id)
    setpaymentDetails(data?.result)
  }



  const handleClose = () => {
    setIsOpen(false)
  }
  return (
    <>
      <div className="booking-details-sec order-details-wrap">
        <div className="booking-details-wrap max-720 mb-4">
          <div className="upcoming-sec">
            <h2>My Orders</h2>

            <div className="bre-wrap ">
              <Breadcrumb title={"Orders"} id={`ORDER ${myOrdersDetails?.orderId}`} navigate={navigate} path={"/my-orders"} />
              <NavLink to="/my-orders"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M7.82843 10.9999H20V12.9999H7.82843L13.1924 18.3638L11.7782 19.778L4 11.9999L11.7782 4.22168L13.1924 5.63589L7.82843 10.9999Z"></path></svg> Back to My Orders</NavLink>
            </div>

            <div className="booking-details-box">
              <div className="booling-id-wrap d-flex align-items-center">
                <div className="booling-id">ORDER {myOrdersDetails?.orderId}</div>
                {(myOrdersDetails?.status == "Unpaid" || myOrdersDetails?.status == "Pending") ? (
                  <div className="up-green up-yellow">
                    <p className="mb-0">{myOrdersDetails?.status}</p>
                  </div>
                ) : (
                  <div className="up-green">
                    <p className="mb-0">{myOrdersDetails?.status}</p>
                  </div>
                )}

              </div>

              <div className="upcoming-heading-wrap ">
                <div className="d-flex align-items-center justify-content-between">

                  <div className="cl-heading-wrap gray-bg">
                    <div className="upcoming-heading">
                      <h5>
                        {`${myOrdersDetails?.orderType?.charAt(0).toUpperCase()}${myOrdersDetails?.orderType?.slice(1)} Cleaning`}
                      </h5>
                    </div>
                    <div className="service-show-list">
                      {
                        selectedServiceList?.map((item, idx) => {
                          return (
                            <p className="mb-0">{item}{selectedServiceList?.length - 1 !== idx ? ',' : ''}</p>
                          )
                        })
                      }
                    </div>
                    <p className="mb-0">Ordered: {getDateTimeValue(myOrdersDetails?.createdAt)}</p>
                  </div>
                  <div className="order-details-right">
                    <h5>$ {getPriceFormatted(myOrdersDetails?.orderAmount)}</h5>
                    {myOrdersDetails?.invoiceURL && <p className="mb-0">
                      {" "}
                      Invoice: <a href={myOrdersDetails?.invoiceURL} target="blank" download>{myOrdersDetails?.invoiceId}</a>
                    </p>}
                    {(myOrdersDetails?.status === "Paid" && paymentDetails?.createdAt) && <p className="mb-0">Paid: {getDateTimeValue(paymentDetails?.createdAt)}</p>}
                  </div>
                </div>
              </div>

              <div className="service-row">
                <div className="row">
                  <div className="col-md-6">
                    <div className="service-row-col-wrap">
                      <h3>Order Details</h3>
                      <div className="sm-det">
                        <h5>Date and Time</h5>
                        {(myOrdersDetails?.svcStartDate) ? <p>{getDateTimeValue(myOrdersDetails?.svcStartDate)}, {myOrdersDetails?.svcEndDate ? formatTimeRange(myOrdersDetails?.svcStartDate, myOrdersDetails?.svcEndDate) : ''} {(myOrdersDetails?.sessions > 1 && myOrdersDetails?.status === 'Paid') ? '(First session)' : ''}</p> : <p>--</p>}
                      </div>
                      {(myOrdersDetails?.preferredDates?.length > 0) ? <div className="sm-det">
                        <h5>Preferred Dates</h5>
                        {myOrdersDetails?.preferredDates?.map((val) => {
                          return (
                            <p>{getDateValueWithSingleTime(val)}</p>
                          )

                        })}

                      </div> : null}
                      <div className="sm-det">
                        <h5>Service Location</h5>
                        <p className={``}>{myOrdersDetails?.formatedAddress}<br />{myOrdersDetails?.address?.displayAddress?.unitNo} <br />Singapore {myOrdersDetails?.address?.displayAddress?.postalCode}<br /><h6 className={``}>{myOrdersDetails?.address?.displayAddress?.generalLocation}</h6></p>
                      </div>
                      {/* <div className="sm-det">
                        <h5>Service Staff</h5>
                        <p>Mary Doe</p>
                      </div> */}
                      <div className="sm-det">
                        <h5>Additional Comment</h5>
                        <p>{myOrdersDetails?.additionalMessage ? myOrdersDetails?.additionalMessage : "--------"}</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="service-row-col-wrap">
                      <h3>Services Booked</h3>
                      {myOrdersDetails?.isAddOnOrder ?
                        <div>
                          Extra {myOrdersDetails.addOnOrderDetails.hour} hours of cleaning with {myOrdersDetails.addOnOrderDetails.noOfStaff} Cleaners
                        </div>
                        : <div className="sm-det">
                          {/* <h5>Services Details:</h5> */}
                          {myOrdersDetails?.services && myOrdersDetails?.services?.length > 0 && myOrdersDetails?.services?.map((item) => {
                            return (
                              <>
                                <p>{item?.serviceName} </p>
                                <p>
                                  {myOrdersDetails?.sessions ? myOrdersDetails?.sessions === 1 ? `${myOrdersDetails?.sessions} Session,` : `${myOrdersDetails?.sessions} Sessions,` : null} {item?.selectedFrequency ? `${item?.selectedFrequency},` : null} {myOrdersDetails?.daysSelected?.length > 0 && myOrdersDetails?.daysSelected?.map((itemDays) => {
                                    return (
                                      <>{itemDays}</>
                                    )
                                  })}
                                  {`${item?.priceDetails?.range ? `${item?.priceDetails?.range} Sqft` : item?.priceDetails?.hdbOptions ? `${item?.priceDetails?.hdbOptions} ${item?.priceDetails?.isTeltCovering && `(Telt Covering)`}` : (myOrdersDetails?.orderType.toLowerCase() === 'general' || myOrdersDetails?.orderType.toLowerCase() === 'regular') ? `${item?.duration} hours` : ''} `}

                                  {item?.selectedTimePrefence ? item?.selectedTimePrefence : null}
                                </p>
                              </>
                            )
                          })}

                        </div>
                      }

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {(myOrdersDetails?.status?.toLowerCase() === "paid" && paymentDetails?.createdAt) ? <div className="transaction-sec max-720 mb-4">
          <h2>Transaction</h2>
          <div className="row">
            <div className="col-md-6">
              <div className="transaction-col">
                <h4>Date and Time </h4>
                <p>{getDateTimeValue(paymentDetails?.createdAt)}</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="transaction-col">
                <h4>Payment Method </h4>
                <p>{paymentDetails?.paymentType}</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="transaction-col">
                <h4>Transaction ID</h4>
                <p>{paymentDetails?.paymentId ? paymentDetails.paymentId : paymentDetails?.offlinePaymentDetails?.transactionId}</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="transaction-col">
                <h4>Amount </h4>
                <p>${paymentDetails?.amount}</p>
              </div>
            </div>
          </div>
        </div> : null}

        {addOnOrderListToShowById && addOnOrderListToShowById?.length > 0 && <div className="order-details-sessions max-720">

          <div className="order-details-sessions-heading">
            Add-On Orders  <img src="/assets/images/uparrow.png" alt="" />
          </div>
          <AddOnOrderDetailsList />
        </div>}
        {jobOrdersListsById && jobOrdersListsById?.length > 0 && <div className="order-details-sessions max-720">

          <div className="order-details-sessions-heading">
            Sessions  <img src="/assets/images/uparrow.png" alt="" />
          </div>

          <OrderDetailsJobList />

        </div>}


      </div>

      <PaymentStatusModal isOpen={isOpen} handleClose={handleClose} />
    </>
  );
};

export default OrderDetails;

